import * as $ from "jquery";
import * as _ from "lodash";
import "select2";
import { ModuleCollection } from "../../../../../collections/Modules";
import { Utils } from "../../../../../common/utils";
import { DashboardChannel } from "../../../../../models/DashboardChannel";
import { DashboardRange } from "../../../../../models/DashboardRange";
import { SensorRecord } from "../../../../../models/Module";
import { BaseModifyDashboardWidgetView, BaseModifyDashboardWidgetViewOptions } from "../_BaseModifyWidgetView";

declare var App: any;


export class ModifyIAQWidgetView extends BaseModifyDashboardWidgetView {

    private widgetChannels: DashboardChannel[];
    private template = _.template(require('templates/modals/dashboard/modify_widgets/iaq/iaq.html'));
    private tempThresholdTemplate = _.template(require('templates/modals/dashboard/modify_widgets/iaq/temperatureThresholds.html'));
    private humThresholdTemplate = _.template(require('templates/modals/dashboard/modify_widgets/iaq/humidityThresholds.html'));
    protected thresholdWrapperTemplate = _.template(require('templates/modals/dashboard/modify_widgets/iaq/thresholdWrapper.html'));
    private locationInputChanged = false;
    private useCustomTitle = false;

    constructor(options: BaseModifyDashboardWidgetViewOptions) {
        super(<any>_.extend({
            tagName: "div",
            className: 'widget-type-iaq',
            events: {
                // Ranges
                'change .advanced-config-checkbox': 'handleConfigToggleChange',
                'click .thresholds-minimized': 'handleThresholdClick',
                'click .use-defaults-btn': 'handleUseDefaultsBtn',
                'click .add-threshold-btn': 'handleAddThreshold',
                'click .delete-threshold-btn, .delete-threshold-btn-mobile': 'handleDeleteThreshold',
                'input .threshold-name, .threshold-value': 'handleThresholdInput',

                'change .custom-labels-config-checkbox': 'handleCustomLabelsToggleChange',
                'change .custom-title-config-checkbox': 'handleCustomTitleToggleChange',

                // Channel
                'click .add-channel-btn': 'handleAddChannel',
                'click .delete-channel-btn': 'handleDeleteChannel',

                // Chart Channel Changes
                'change .install-select': 'handleInstallSelectChange',
                'change .module-select': 'handleModuleSelectChange',
                'input .location-input': 'handleLocationInput',
                
                'change .tab select': 'handleTabChange'
            }
        }, options));

        this.widgetChannels = null;
        if (!this.options.widget) {
            this.options.widget = new this.options.dashboardWidgetCollection.model({
                dashboard_id: this.options.dashboardId,
                params: []
            });
            this.widgetChannels = [];
        } else {
            this.widgetChannels = this.options.dashboardChannelCollection.where({
                dashboard_widget_id: this.options.widget.get('id')
            });
        }
    }

    render() {
        var selectedInstallId = App.getLastSelectedInstallId();
        if (this.widgetChannels.length) {
            var c = _.first(this.widgetChannels);
            selectedInstallId = c.get('install_id');
        }

        const rawAdvancedConfig = this.options.widget.getParamValue('ADVANCED_CONFIG', false);
        // coerce the raw value -- which may be a boolean, number, or string -- into a boolean
        this.advancedConfig = !!Number(rawAdvancedConfig);

        const rawUseCustomTitleConfig = this.options.widget.getParamValue('USE_CUSTOM_TITLE', false);
        // coerce the raw value -- which may be a boolean, number, or string -- into a boolean
        this.useCustomTitle = !!Number(rawUseCustomTitleConfig);

        const rawUseCustomLabelsConfig = this.options.widget.getParamValue('USE_CUSTOM_LABELS', false);
        // coerce the raw value -- which may be a boolean, number, or string -- into a boolean
        this.useCustomLabels = !!Number(rawUseCustomLabelsConfig);

        this.$el.html(this.template({
            dashboardCategoryCollection: this.options.dashboardCategoryCollection,
            dashboardTabCollection: this.options.dashboardTabCollection,
            widget: this.options.widget,
            img_url: require('../../../../../../img/widgettypes/iaq/iaq.png'),
            categoryId: this.options.widget.get('dashboard_category_id') ?
                this.options.widget.get('dashboard_category_id') : this.options.categoryId,
            tabId: this.options.tabId,
            organizationCollection: this.options.organizationCollection,
            installCollection: this.options.installCollection,
            lastSelectedInstallId: selectedInstallId,
            advancedConfig: this.advancedConfig,
            useCustomLabels: this.useCustomLabels,
            useCustomTitle: this.useCustomTitle
        }));
        this.$('select').select2(Utils.Select2.defaultOptions);
        this.$('.install-select').trigger('change');

        //Initialize bootstraptoggle for advanced configuration
        (<any>this.$el.find('input[type="checkbox"]')).bootstrapToggle();

        return this;
    }

    show() {
        // Refit selects to container width after it is rendered on screen
        this.$('.channels').find('select').select2(Utils.Select2.defaultOptions);
        this.$('.tab select').select2(Utils.Select2.defaultOptions);
        this.initializeCategorySelect('.category select');
    }

    handleTabChange(e: JQuery.Event) {
        var $select = this.$('.tab select');
        var rawValue = $select.val();
        var tabId = rawValue === '' || rawValue === null || rawValue === undefined ? null : Number(rawValue);
        this.options.tabId = tabId;
        this.reloadCategoriesForTab(tabId);
    }

    checkCanSaveWidget() {
        var module = this.$('.module-select').val();
        var savable = !isNaN(Number(module)) && module && this.$('.location-input').val();
        this.options.parentView.setSavable(savable);
        return savable;
    }

    private getIAQLikeSensorTypes() {
        // IAQ like sensor types, for example the internal sensor, deprecated environmental sensor
        return [
            34, // IAQ Sensor
            30, // Environmental Sensor (deprecated),
            1   // Internal Sensor
        ];
    }

    private buildModuleOptions(installId) {
        var options = [];

        var selectedModuleNumber = App.getLastSelectedModuleNumber();
        if (this.widgetChannels.length) {
            var c = _.first(this.widgetChannels);
            if (c.get('install_id') === installId) {
                selectedModuleNumber = c.get('module_number');
            }
        }

        var IAQLikeSensorTypes = this.getIAQLikeSensorTypes();
        this.options.moduleCollections[installId].each((module) => {
            // Filter Modules that don't have sensors connected. Control sensors are not
            // Considered sensors in this case
            for (var i = 1; i < 5; i++) {
                var con = module.getConnector(i);
                if (con) {
                    if (!_.includes(IAQLikeSensorTypes, con['sensor_type'])) continue;

                    var mod = module.get('module_number');
                    var option = { id: mod, text: module.getDisplayName(), selected: '' };
                    if (mod === selectedModuleNumber) option.selected = "selected";
                    options.push(option);
                    break;
                }
            }
        });

        if (options.length) return options;
        return [{ id: '', text: 'No Modules with Indoor Air Quality Sensors Found' }]
    }

    private handleInstallSelectChange(e: JQuery.UIEventBase) {
        var installSelect = $(e.currentTarget);
        var installId = Number($(installSelect).val());

        if (!installId) return;

        // Save this as the last selected Id on the dashboard
        App.setLastSelectedInstallId(installId);

        var moduleSelect = this.$('.module-select');
        moduleSelect.empty();

        if (this.options.permissionCollection.canViewInstall(Number(installId))) {
            if (!_.has(this.options.moduleCollections, installId)) {
                this.options.moduleCollections[installId] = new ModuleCollection([], { installId: installId });
                this.options.moduleCollections[installId].fetch();
            }

            if (this.options.moduleCollections[installId].isFetching()) {
                moduleSelect.append('<option value="">Loading...</option>');

                this.options.moduleCollections[installId].once('sync', () => {
                    moduleSelect.empty().select2(_.extend({
                        disabled: false,
                        data: this.buildModuleOptions(installId),
                    }, Utils.Select2.defaultOptions));
                    moduleSelect.trigger('change');
                });
            } else {
                moduleSelect.select2(_.extend({
                    disabled: !installId,
                    data: this.buildModuleOptions(installId),
                }, Utils.Select2.defaultOptions));
            }
        } else {
            moduleSelect.select2(_.extend({
                disabled: !installId,
            }, Utils.Select2.defaultOptions));
        }

        moduleSelect.trigger('change');
    }

    private handleModuleSelectChange(e: JQuery.UIEventBase) {
        var moduleSelect = $(e.currentTarget);
        var moduleNumber = moduleSelect.val();
        if (!moduleNumber || moduleNumber == 'No Modules with Indoor Air Quality Sensors Found') {
            $('.iaq-thresholds').addClass('hidden');
            return;
        }
        $('.iaq-thresholds').removeClass('hidden');

        // Save this as the last selected module number on the dashboard
        App.setLastSelectedModuleNumber(moduleNumber);
        this.setLocation();

        var canSave = this.checkCanSaveWidget();
        this.$('.thresholds').toggleClass('hidden', !canSave);

        // Set regular thresholds
        this.setThresholds();
        // Set multiranges thresholds
        this.setMultiRanges();

        //Build channel select options
        this.buildChannelOptions();

        //Hide/Show Add Channel button
        this.onUpdateChannelRows();
    }

    private handleLocationInput() {
        this.locationInputChanged = true;
        this.checkCanSaveWidget();
    }

    private setLocation() {
        var installId = Number(this.$('.install-select').val());
        var moduleNumber = this.$('.module-select').val();

        if (!installId || !moduleNumber) {
            this.$('.location-input').val('');
            return;
        }

        var customLocation = this.options.widget.getParamValue('LOCATION', '');
        var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
        var moduleLocation = module.get('module_location');
        var allLocations = this.options.moduleCollections[installId].map((m) => {
            return m.get('module_location')
        });

        if (!this.locationInputChanged) {
            if (!this.options.widget.isNew() && !_.includes(allLocations, customLocation)) {
                if(this.useCustomTitle) {
                    this.$('.location-input').val(customLocation);
                } else {
                    this.$('.location-input').val(moduleLocation);
                }
            } else {
                this.$('.location-input').val(moduleLocation);
            }
        }
    }

    private handleThresholdClick(e: JQuery.UIEventBase) {
        var thresholdsContainer = $(e.currentTarget).parents('.channel-thresholds').find('.thresholds');
        var channelBtns = $(e.currentTarget).parents('.channel-thresholds').find('.channel-btns');
        var expanded = thresholdsContainer.hasClass('expanded');
        if (expanded) {
            thresholdsContainer.slideUp(400);
            thresholdsContainer.removeClass('expanded');
            channelBtns.addClass('hidden');
        } else {
            thresholdsContainer.slideDown(400);
            thresholdsContainer.addClass('expanded');
            channelBtns.removeClass('hidden');
        }
    }

    private isChannelSelected(channelId) {
        var channelSelected = false;
        _.each(this.$('.channel-thresholds'), (channelRow) => {
            if ($(channelRow).attr('data-channel-id') == channelId) {
                channelSelected = true;
                return false;
            }
        });
        return channelSelected;
    }

    private handleAddChannel(e: JQuery.UIEventBase) {
        e.preventDefault();
        var channelId = Number($('.channel-select').val());
        if(!channelId) return;

        var installId = Number(this.$('.install-select').val());
        var moduleNumber = this.$('.module-select').val();
        if (!installId || !moduleNumber || this.isChannelSelected(channelId)) return;

        var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
        var channel = module.getChannelById(channelId);

        var dashboardChannel = _.find(this.widgetChannels, (c) => {
            return c.get('channel_id') === channelId;
        });
        var channelName = dashboardChannel ? dashboardChannel.get('channel_name') : channel.channel_name;
        var channelUnit = channel.channel_unit;

        $('.thresholds-multirange').append(this.thresholdWrapperTemplate({
            useCustomLabels: this.useCustomLabels,
            channelId: channel.channel_id,
            dashboardChannelId: dashboardChannel ? dashboardChannel.get('dashboard_channel_id') : '',
            type: channel.channel_name,
            unit: channelUnit,
            channelName: channelName,
            dashboardChannelName: dashboardChannel ? dashboardChannel.get('dashboard_channel_name') : channelName
        }));

        // Add defaultRanges if its one of the types that has defaults
        var channelOrder = this.getChannelOrder(channel);

        let rangesList = this.getDefaultIAQRangesByChannelOrder(channelOrder, channelUnit);
        if(channel.channel_virtual){
            rangesList = this.getDefaultIAQRangesByVirtualChannel(channel);
        }

        if (rangesList.length > 1) {
            var thresholdsWrapper = this.$(`[data-channel-id="${channel.channel_id}"]`).find('.thresholds-wrapper');
            this.renderRanges(thresholdsWrapper, rangesList, channelUnit);
        }
        // Diasable channel on select
        this.buildChannelOptions();

        //Hide/Show Add Channel button
        this.onUpdateChannelRows();
    }

    private handleDeleteChannel(e: JQuery.UIEventBase) {
        // Remove elements generated by Spectrum Color Picker
        var colorPickerInputs = $(e.currentTarget).parents('.channel-thresholds').find('.threshold-range .threshold-color.color-picker');
        _.each(colorPickerInputs, (cp) => {
            var $cp = $(cp);
            (<any>$cp).spectrum("container").remove();
        });
        $(e.currentTarget).parents('.channel-thresholds').remove();
        //Enable channel on select
        this.buildChannelOptions();

        //Hide/Show Add Channel button
        this.onUpdateChannelRows();
    }

    private onUpdateChannelRows(){
        const rows = this.$('.channel-thresholds');
        if (rows.length >= 14) {
            $('.add-channel').hide()
        } else{
            $('.add-channel').show();
        }
    }

    private setThresholds() {
        var installId = Number(this.$('.install-select').val());
        var moduleNumber = this.$('.module-select').val();
        if (!installId || !moduleNumber) return;

        var availableChannels = this.getModuleChannelsFromUI();
        this.$('.thresholds-limits').empty();
        if (availableChannels.has('temp')) {
            let tempThresholds;
            var tempChannel = _.find(this.widgetChannels, (c) => {
                return c.get('dashboard_channel_order') === 1
            });
            if (tempChannel &&
                tempChannel.get('install_id') === installId &&
                tempChannel.get('module_number') === moduleNumber &&
                !this.advancedConfig) {
                // Get values from rangesList
                tempThresholds = this.getThresholdsLimitsFromRangesList(tempChannel.get('rangesList'));
            } else {
                var isCelcius = false;
                var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
                for (var i = 5; i > 0; i--) {
                    var con = module.getConnector(i);
                    if (con && _.includes(this.getIAQLikeSensorTypes(), con.sensor_type)) {
                        _.each(con.channels, (c) => {
                            if (c.channel_unit.toLowerCase() === '°c' || c.channel_unit.toLowerCase() === 'c') isCelcius = true
                        })
                    }
                }
                tempThresholds = {
                    critLowVal: isCelcius ? 18 : 66,
                    warningLowVal: isCelcius ? 20 : 68,
                    warningHighVal: isCelcius ? 23 : 74,
                    critHighVal: isCelcius ? 25 : 77
                }
            }
            this.$('.thresholds-limits').append(this.tempThresholdTemplate({
                tempThresholds: tempThresholds
            }))
        }

        if (availableChannels.has('hum')) {
            let humThresholds;
            var humChannel = _.find(this.widgetChannels, (c) => {
                return c.get('dashboard_channel_order') === 2
            });
            if (humChannel &&
                humChannel.get('install_id') === installId &&
                humChannel.get('module_number') === moduleNumber &&
                !this.advancedConfig) {
                // Get values from rangesList
                humThresholds = this.getThresholdsLimitsFromRangesList(humChannel.get('rangesList'));
            } else {
                humThresholds = {
                    critLowVal: 20,
                    warningLowVal: 30,
                    warningHighVal: 70,
                    critHighVal: 80
                }
            }

            this.$('.thresholds-limits').append(this.humThresholdTemplate({
                humThresholds: humThresholds
            }))
        }
    }

    private setMultiRanges() {
        this.$('.thresholds-multirange').empty();

        var installId = Number(this.$('.install-select').val());
        var moduleNumber = this.$('.module-select').val();

        var selectedInstallId = App.getLastSelectedInstallId();
        var selectedModuleNumber = App.getLastSelectedModuleNumber();
        if (this.widgetChannels.length) {
            var c = _.first(this.widgetChannels);
            selectedInstallId = c.get('install_id');
            if (c.get('install_id') === installId) {
                selectedModuleNumber = c.get('module_number');
            }
        }
        // If this is a new Widget or the advanced configuration is set to regular or the user changed the module,
        // render default ranges for default channels
        if (this.options.widget.isNew() || !this.advancedConfig || installId != selectedInstallId || moduleNumber != selectedModuleNumber) {
            const availableChannels = this.getModuleChannelsFromUI();
            // Sort channles by order
            const availableChannelsSorted = new Map([...availableChannels.entries()].sort((a, b) => {
                return a[1].order - b[1].order
            }));


            for (const [type, channel] of availableChannelsSorted.entries()) {
                var channelUnit = channel.channel.channel_unit;
                const dChannel = this.widgetChannels.find(c => c.get('dashboard_channel_order') === channel.order);

                $('.thresholds-multirange').append(this.thresholdWrapperTemplate({
                    useCustomLabels: this.useCustomLabels,
                    channelId: channel.channel.channel_id,
                    dashboardChannelId: dChannel ? dChannel.get('id') : '',
                    type: type,
                    unit: channelUnit,
                    channelName: channel.channel.channel_name,
                    dashboardChannelName: dChannel ? dChannel.get('dashboard_channel_name') : channel.channel.channel_name
                }));

                let rangesList = this.getDefaultIAQRangesByChannelOrder(channel.order, channelUnit);
                if(channel.channel_virtual){
                    rangesList = this.getDefaultIAQRangesByVirtualChannel(channel);
                }
                
                var row = $(`.${type}`).find('.thresholds-wrapper');
                this.renderRanges(row, rangesList, channelUnit);
            }

        } else { // This is an existing widget, render rangesList for each widget channel
            // Sort channels by dashboard_channel_order
            // Place non-IAQ channels(dashboard_channel_order = 0) at the end sorted by dashboard_channel_id
            this.widgetChannels.sort((a, b) => {
                const a_id = a.get('dashboard_channel_id');
                let a_order = a.get('dashboard_channel_order');
                const b_id = b.get('dashboard_channel_id');
                let b_order = b.get('dashboard_channel_order');

                // Channels with an order of 0 should always be last
                // in the list. We do this by treating them as the
                // largest possible value to keep the comparisons
                // below simple, but an alternative could be checking
                // for 0 in the comparisons below. Since we already
                // have the if() statement, we add a check for
                // non-numeric values as well -- just to be thorough.
                if (a_order < 1 || !Number.isFinite(a_order)) { a_order = Number.MAX_VALUE; }
                if (b_order < 1 || !Number.isFinite(b_order)) { b_order = Number.MAX_VALUE; }

                if (a_order == b_order) {
                    // Channels with the same order should be sorted by
                    // their ID so that the same collection of input
                    // channels always produces the same output ordering
                    // regardless of the ordering of the input channels.
                    if (a_id == b_id) {
                        return 0;
                    } else if (a_id < b_id) {
                        return -1;
                    } else {
                        return 1;
                    }
                } else if (a_order < b_order) {
                    return -1;
                } else {
                    return 1;
                }
            });

            _.each(this.widgetChannels, (dchannel) => {
                var channelUnit = dchannel.get('channel_unit');

                $('.thresholds-multirange').append(this.thresholdWrapperTemplate({
                    useCustomLabels: this.useCustomLabels,
                    channelId: dchannel.get('channel_id'),
                    dashboardChannelId: dchannel.get('dashboard_channel_id'),
                    type: dchannel.get('channel_name'),
                    unit: channelUnit,
                    channelName: dchannel.get('channel_name'),
                    dashboardChannelName: dchannel.get('dashboard_channel_name')
                }));

                var row = this.$(`[data-channel-id="${dchannel.get('channel_id')}"]`).find('.thresholds-wrapper');
                this.renderRanges(row, dchannel.get('rangesList'), channelUnit);
            });
        }
    }

    handleUseDefaultsBtn(e: JQuery.UIEventBase) {
        e.preventDefault();
        var installId = Number(this.$('.install-select').val());
        var moduleNumber = this.$('.module-select').val();
        if (!installId || !moduleNumber) return;

        var thresholdsWrapper = $(e.currentTarget).parents('.channel-thresholds').find('.thresholds-wrapper');
        var channelId = Number($(e.currentTarget).parents('.channel-thresholds').attr('data-channel-id'));
        var channelUnit = $(e.currentTarget).parents('.channel-thresholds').attr('data-channel-unit');

        var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
        var channel = module.getChannelById(channelId);
        var dashboardChannel = _.find(this.widgetChannels, (c) => {
            return c.get('channel_id') === channelId;
        });

        var channelOrder = this.getChannelOrder(channel);
        let rangesList = this.getDefaultIAQRangesByChannelOrder(channelOrder, channelUnit);
        if(dashboardChannel.get('channel_virtual')){
            rangesList = this.getDefaultIAQRangesByVirtualChannel(channel);
        }

        if (rangesList.length > 1) {
            // Remove elements generated by Spectrum Color Picker
            var colorPickerInputs = thresholdsWrapper.find('.threshold-range .threshold-color.color-picker');
            _.each(colorPickerInputs, (cp) => {
                var $cp = $(cp);
                (<any>$cp).spectrum("container").remove();
            });

            thresholdsWrapper.empty();
            this.renderRanges(thresholdsWrapper, rangesList, channelUnit);
            this.handleThresholdInput();
        } else {
            (<any>$).notify({
                title: 'This channel does not have default ranges',
                message: '',
                icon: 'fa fa-exclamation-circle',
            }, {
                animate: {
                    enter: 'animated fadeInUp',
                },
                // The type property defines the css style
                // See alerts.less for available styles
                type: "warning-alt",
                placement: { from: "bottom", align: "center" }
            });
        }
    }

    handleCustomTitleToggleChange(e: JQuery.UIEventBase) {
        e.preventDefault();

        this.useCustomTitle = $(e.currentTarget).is(':checked');
        if(this.useCustomTitle){
            this.$('.location-input').prop('disabled', false);
        } else {
            const installId = Number(this.$('.install-select').val());
            const moduleNumber = this.$('.module-select').val();
            const module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
            const moduleLocation = module.get('module_location');
            this.$('.location-input').val(moduleLocation);
            this.$('.location-input').prop('disabled', true);
        }
    }

    renderRanges(row, rangesList, channelUnit) {
        var $row = $(row);
        var useMin = false;
        _.sortBy(rangesList, r => r.max).forEach(range => {
            if (!(range instanceof DashboardRange)) range = new DashboardRange(range);
            var value;
            if (range.get('is_default')) {
                useMin = true;
                return
            }
            useMin ? value = range.get('min') : value = range.get('max');

            $row.append(this.thresholdTemplate({
                id: range.get('id'),
                name: range.get('name'),
                value: value,
                unit: channelUnit,
                color: range.get('color'),
                aboveThreshold: useMin ? true : false
            }));
            (<any>this.$('input[type="checkbox"]')).bootstrapToggle();
        });

        // Initialize Spectrum color picker
        (<any>$row.find('.color-picker')).spectrum(this.getSpectrumDefaultOptions());
    }

    private getModuleChannelsFromUI(): Map<string, any> {
        var installId = Number(this.$('.install-select').val());
        var moduleNumber = this.$('.module-select').val();
        if (!installId || !moduleNumber) return new Map();

        var sensors = [];
        var IAQLikeSensorTypes = this.getIAQLikeSensorTypes();
        var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
        for (var i = 5; i > 0; i--) {
            var con = module.getConnector(i);
            if (con && _.includes(IAQLikeSensorTypes, con.sensor_type)) sensors.push(con);
        }

        const expectedChannels: Map<string, any> = new Map();
        _.each(sensors, (s: SensorRecord) => {
            var positions = {};
            if (s.sensor_type === 1) {
                // Internal Sensor
                if (s.sensor_version >= 5) {
                    positions = {
                        'temp': [1, 1],
                        'hum': [2, 2],
                    };
                } else {
                    positions = {
                        'temp': [2, 1],
                        'hum': [3, 2],
                    };
                }
            } else if (s.sensor_type === 30) {
                // Old Environmental
                positions = {
                    'temp': [1, 1],
                    'hum': [2, 2],
                    'co2': [3, 3],
                    'voc': [4, 4],
                    'pm25': [10, 7],
                    'pm10': [11, 8]
                }
            } else if (s.sensor_type === 34) {
                // IAQ
                positions = {
                    'temp': [1, 1],
                    'hum': [2, 2],
                    'co2': [3, 3],
                    'voc': [4, 4],
                    'pm25': [7, 7],
                    'pm10': [8, 8],
                    'hcho': [99, 99],
                    'no2': [100, 100],
                    'h2s': [103, 103],
                    'so2': [106, 106],
                    'o3': [109, 109],
                    'co': [112, 112]
                }
                // Override defaults as needed for later versions of the sensor.
                if (s.sensor_version === 2 || s.sensor_version === 3 || s.sensor_version === 7) {
                    positions['pm25'] = [90, 7];
                    positions['pm10'] = [92, 8];
                    if (s.sensor_version === 7) { // For Tera PM, we want to show PM1.0
                        positions['pm1'] = [89, 6];
                    }
                } else if (s.sensor_version === 4 || s.sensor_version === 5) {
                    positions['pm25'] = [90, 7];
                    positions['pm10'] = [91, 8];
                    if (s.sensor_version === 5) { // For Tera PM, we want to show PM1.0
                        positions['pm1'] = [89, 6];
                    }
                }
            }

            _.each(positions, (position, type) => {
                var channel = _.find(s.channels, { channel_position: position[0] });
                if (channel) {
                    expectedChannels.set(type, {
                        channel: channel,
                        order: position[1]
                    });
                }
            });
        });
        return expectedChannels;
    }

    private buildChannelOptions() {
        var installId = Number(this.$('.install-select').val());
        var moduleNumber = this.$('.module-select').val();
        var channelSelect = this.$('.channel-select');
        if (!installId || !moduleNumber) return;

        channelSelect.empty();
        var channelOptions = [{ id: '', text: '' }];
        if (moduleNumber) {
            var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
            if (module) {
                _.each([1, 2, 3, 4], (connector) => {
                    var con = module.getConnector(connector);
                    if (con) {
                        var label = 'Connector ' + connector + ': ' + con['sensor_name'];
                        if (!module.showConnector(connector)) label += ' (disconnected)';

                        var optgroup = { text: label, children: [] };
                        _.each(_.sortBy(con.channels, 'channel_position'), (c) => {
                            var isDisabled = this.isChannelSelected(c['channel_id']);
                            optgroup.children.push({ id: c['channel_id'], text: c['channel_name'], disabled: isDisabled });
                        });

                        channelOptions.push(<any>optgroup);
                    }
                });
            }
        }
        channelSelect.select2(_.extend({
            disabled: !moduleNumber,
            data: channelOptions,
        }, Utils.Select2.defaultOptions));
    }

    preSave() {
        this.options.widget.setParamValue('LOCATION', this.$('.location-input').val());
        this.options.widget.setParamValue('ADVANCED_CONFIG', this.advancedConfig);
        // Custom labels cannot be used on regular config
        if(!this.advancedConfig) this.useCustomLabels = false;
        this.options.widget.setParamValue('USE_CUSTOM_LABELS', this.useCustomLabels);
        this.options.widget.setParamValue('USE_CUSTOM_TITLE', this.useCustomTitle);
        return true;
    }

    getChannelDifference() {
        if (this.advancedConfig) {
            return this.getChannelDifferenceForAdvancedConfig();
        } else {
            return this.getChannelDifferenceForDefaultConfig();
        }
    }

    getChannelDifferenceForAdvancedConfig() {
        var installId = Number(this.$('.install-select').val());
        var moduleNumber = this.$('.module-select').val();
        if (!installId || !moduleNumber) return [];

        var channelsSeen = [];
        var create = [];
        var update = {};
        var location = this.$('.location-input').val();
        var rows = this.$('.channel-thresholds');

        _.each(rows, (row, i) => {
            var $row = $(row);
            var channelId = Number($row.attr('data-channel-id'));
            var dashboardChannelId = Number($row.attr('data-dashboard-channel-id'));

            var dashboardChannel = null;
            if (dashboardChannelId) {
                dashboardChannel = _.find(this.widgetChannels, (c) => {
                    return c.get('dashboard_channel_id') === dashboardChannelId;
                });
            }

            var moduleNumber = this.$('.module-select').val();
            var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
            var channel = module.getChannelById(channelId);

            //Get rangeList for channel
            var rangesList = this.getRangesListFromAdvancedThresholds(row);
            var order = this.getChannelOrder(channel);

            // Change names of default range for Temperature and Humidity
            if (order == 1 || order == 2) {
                var defaultRange = _.find(rangesList, (r) => {
                    return r.get('is_default') === true;
                });
                if (defaultRange) defaultRange.set({ name: 'Comfortable' });
            }

            // Use default name or custom name based on configuration
            let name = `${channel['channel_name']}`;
            if(this.advancedConfig && this.useCustomLabels) {
                name =  (<string>$row.find('.widget-channel-label').val()).trim();
            }

            var upsert = {
                dashboardId: this.options.dashboardId,
                widgetId: this.options.widget.get('id'),
                channelId: channelId,
                order: order,
                name: name,
                critLow: null,
                warnLow: null,
                warnHigh: null,
                critHigh: null,
                rangesList: rangesList
            };

            if (dashboardChannel) {
                channelsSeen.push(dashboardChannelId);
                update[dashboardChannelId] = upsert;
            } else {
                create.push(upsert);
            }
        });

        var _delete = [];
        _.each(this.widgetChannels, (c) => {
            var dcid = c.get('dashboard_channel_id');
            if (!_.includes(channelsSeen, dcid)) _delete.push(dcid);
        });

        return [create, update, _delete]
    }

    // If channel is an IAQ channel, get its position to use as order
    // Non IAQ channels order should be set to 0
    getChannelOrder(channel) {
        let order = 0;

        // Special case for Tera PM 1.0
        if(channel.channel_position === 89) {
            order = 6;
        } else{
            const expectedChannels = this.getModuleChannelsFromUI();
            expectedChannels.forEach((c, type) => {
                if (c.channel.channel_id == channel.channel_id) {
                    order = c.order;
                }
            });
        }

        return order;
    }

    getRangesListFromRegularThresholds(order) {
        const rangesList = [];
        let limitCritLowId = null;
        let critLow = null;
        let limitWarnLowId = null;
        let warnLow = null;
        let limitWarnHighId = null;
        let warnHigh = null;
        let limitCritHighId = null;
        let critHigh = null;
        switch (order) {
            case 1:
                critLow = Number(this.$('.thresholds .temperature .crit-low').val()) ?? null;
                warnLow = Number(this.$('.thresholds .temperature .warn-low').val()) ?? null;
                warnHigh = Number(this.$('.thresholds .temperature .warn-high').val()) ?? null;
                critHigh = Number(this.$('.thresholds .temperature .crit-high').val()) ?? null;
                break;
            case 2:
                critLow = Number(this.$('.thresholds .humidity .crit-low').val()) ?? null;
                warnLow = Number(this.$('.thresholds .humidity .warn-low').val()) ?? null;
                warnHigh = Number(this.$('.thresholds .humidity .warn-high').val()) ?? null;
                critHigh = Number(this.$('.thresholds .humidity .crit-high').val()) ?? null;
                break;
            case 3:
                critLow = null;
                warnLow = null;
                warnHigh = 1000;
                critHigh = 2000;
                break;
            case 4:
                critLow = null;
                warnLow = null;
                warnHigh = 325;
                critHigh = 500;
                break;
            case 7:
                critLow = null;
                warnLow = null;
                warnHigh = 12.1;
                critHigh = 55.5;
                break;
            case 8:
                critLow = null;
                warnLow = null;
                warnHigh = 54;
                critHigh = 255;
                break;
        }

        const dChannel = this.widgetChannels.find(c => c.get('dashboard_channel_order') === order);
        if (dChannel) {
            const limits = this.getThresholdsLimitsFromRangesList(dChannel.get('rangesList'));
            limitCritLowId = limits.critLowId ?? null;
            limitWarnLowId = limits.warningLowId ?? null;
            limitWarnHighId = limits.warningHighId ?? null;
            limitCritHighId = limits.critHighId ?? null;
        }

        // Critical - Low
        if (critLow != null) {
            var thresholdRange = new DashboardRange();
            thresholdRange.set({
                id: limitCritLowId ?? null,
                name: "Critical Low",
                min: null,
                max: critLow,
                color: order == 1 ? Utils.colors.blue : Utils.colors.red,
                description: 'Value below threshold',
            });
            rangesList.push(thresholdRange);
        }
        // Warning - Low
        if (warnLow != null) {
            var thresholdRange = new DashboardRange();
            thresholdRange.set({
                id: limitWarnLowId ?? null,
                name: "Warning Low",
                min: null,
                max: warnLow,
                color: order == 1 ? Utils.colors["light-blue"] : Utils.colors.yellow,
                description: 'Value below threshold',
            });
            if (critLow != null) {
                thresholdRange.setMin(critLow);
            }
            rangesList.push(thresholdRange);
        }
        //Create default range
        var thresholdRange = new DashboardRange({
            name: "Good",
            description: 'Value within threshold',
            color: Utils.colors.green,
            is_default: true,
            min: null,
            max: null
        });
        if (warnLow != null) {
            thresholdRange.setMin(warnLow);
        } else if (critLow != null) {
            thresholdRange.setMin(critLow);
        }
        if (warnHigh != null) {
            thresholdRange.setMax(warnHigh);
        } else if (critHigh != null) {
            thresholdRange.setMax(critHigh);
        }
        rangesList.push(thresholdRange);

        // Warning - High
        if (warnHigh != null) {
            var thresholdRange = new DashboardRange();
            thresholdRange.set({
                id: limitWarnHighId ?? null,
                name: "Warning High",
                min: warnHigh,
                max: null,
                color: Utils.colors.yellow,
                description: 'Value above threshold',
            });
            if (critHigh != null) {
                thresholdRange.setMax(critHigh);
            }
            rangesList.push(thresholdRange);
        }
        // Critical - High
        if (critHigh != null) {
            var thresholdRange = new DashboardRange();
            thresholdRange.set({
                id: limitCritHighId ?? null,
                name: "Critical High",
                min: critHigh,
                max: null,
                color: Utils.colors.red,
                description: 'Value above threshold',
            });
            //add color, desc and icon
            rangesList.push(thresholdRange);
        }

        return rangesList;
    }

    getChannelDifferenceForDefaultConfig() {
        var installId = Number(this.$('.install-select').val());
        var moduleNumber = this.$('.module-select').val();
        if (!installId || !moduleNumber) return [];

        // Determine which channels are available
        var expectedChannels = this.getModuleChannelsFromUI();

        var channelsSeen = [];
        var create = [];
        var update = {};
        var location = this.$('.location-input').val();
        expectedChannels.forEach((c, type) => {
            var upsert = {
                dashboardId: this.options.dashboardId,
                widgetId: this.options.widget.get('id'),
                channelId: c.channel.channel_id,
                order: c.order,
                name: location + ' - ' + c.channel.channel_name,
                critLow: null,
                warnLow: null,
                critHigh: null,
                rangesList: this.getRangesListFromRegularThresholds(c.order)
            };

            var dashboardChannel = _.find(this.widgetChannels, (c) => {
                return c.get('channel_id') === upsert.channelId;
            });

            if (dashboardChannel) {
                var dashboardChannelId = dashboardChannel.get('dashboard_channel_id');
                channelsSeen.push(dashboardChannelId);
                update[dashboardChannelId] = upsert;
            } else {
                create.push(upsert);
            }
        });

        var _delete = [];
        _.each(this.widgetChannels, (c) => {
            var dcid = c.get('dashboard_channel_id');
            if (!_.includes(channelsSeen, dcid)) _delete.push(dcid);
        });

        return [create, update, _delete]
    }


    private getDefaultIAQRangesByVirtualChannel(channel) {
        // Define the configuration for each channel type
        const channelConfigurations = [
            {
                regex: /vpi/i, // Case-insensitive regex for 'vpi'
                ranges: [
                    new DashboardRange({
                        name: 'Poor',
                        description: 'Value below threshold',
                        color: Utils.colors.red,
                        min: null,
                        max: 40,
                        icon: 'fa-circle-arrow-up',
                    }),
                    new DashboardRange({
                        name: 'Moderate',
                        description: 'Value below threshold',
                        color: Utils.colors.yellow,
                        min: 40,
                        max: 70,
                        icon: 'fa-circle-arrow-down',
                    }),
                    new DashboardRange({
                        name: 'Comfortable',
                        description: 'Value within threshold',
                        color: Utils.colors.green,
                        is_default: true,
                        min: 70,
                        max: null,
                    }),
                ],
            },
            {
                regex: /aqi/i, // Case-insensitive regex for 'aqi'
                ranges: [
                    new DashboardRange({
                        name: 'Good',
                        description: 'Value within threshold',
                        color: Utils.colors.green,
                        min: null,
                        max: 50,
                        is_default: true,
                    }),
                    new DashboardRange({
                        name: 'Moderate',
                        description: 'Value above threshold',
                        color: Utils.colors.yellow,
                        min: 50,
                        max: 100,
                        icon: 'fa-circle-arrow-up',
                    }),
                    new DashboardRange({
                        name: 'USG',
                        description: 'Value above threshold',
                        color: Utils.colors.orange,
                        min: 100,
                        max: 150,
                        icon: 'fa-circle-arrow-up',
                    }),
                    new DashboardRange({
                        name: 'Unhealthy',
                        description: 'Value above threshold',
                        color: Utils.colors.red,
                        min: 150,
                        max: 200,
                        icon: 'fa-circle-arrow-up',
                    }),
                    new DashboardRange({
                        name: 'Very Unhealthy',
                        description: 'Value above threshold',
                        color: Utils.colors.purple,
                        min: 200,
                        max: 300,
                        icon: 'fa-circle-arrow-up',
                    }),
                    new DashboardRange({
                        name: 'Hazardous',
                        description: 'Value above threshold',
                        color: Utils.colors.maroon,
                        min: 300,
                        max: null,
                        icon: 'fa-circle-arrow-up',
                    }),
                ],
            },
        ];
    
        // Match the channel name with the appropriate configuration
        for (const config of channelConfigurations) {
            if (config.regex.test(channel.channel_name)) {
                return config.ranges;
            }
        }
    
        // Default range if no match is found
        return [
            new DashboardRange({
                name: 'Good',
                description: 'Value within threshold',
                color: Utils.colors.green,
                min: null,
                max: null,
                is_default: true,
            }),
        ];
    }    

    private getDefaultIAQRangesByChannelOrder(order: number, unit: string) {
        switch (order) {
            case 1: //Temerature
                const isCelcius = unit.toLowerCase() === '°c' || unit.toLowerCase() === 'c';
                return [new DashboardRange({
                    name: 'Cold',
                    description: 'Value below threshold',
                    color: Utils.colors.blue,
                    min: null,
                    max: isCelcius ? 18 : 66,
                    icon: 'fa-circle-arrow-down'
                }), new DashboardRange({
                    name: 'Cool',
                    description: 'Value below threshold',
                    color: Utils.colors["light-blue"],
                    min: isCelcius ? 18 : 66,
                    max: isCelcius ? 20 : 68,
                    icon: 'fa-circle-arrow-down'
                }), new DashboardRange({
                    name: 'Comfortable',
                    description: 'Value within threshold',
                    color: Utils.colors.green,
                    is_default: true,
                    min: isCelcius ? 20 : 68,
                    max: isCelcius ? 23 : 74,
                }), new DashboardRange({
                    name: 'Warm',
                    description: 'Value above threshold',
                    color: Utils.colors.yellow,
                    min: isCelcius ? 23 : 74,
                    max: isCelcius ? 25 : 77,
                    icon: 'fa-circle-arrow-up'
                }), new DashboardRange({
                    name: 'Hot',
                    description: 'Value above threshold',
                    color: Utils.colors.red,
                    min: isCelcius ? 25 : 77,
                    max: null,
                    icon: 'fa-circle-arrow-up'
                })]
            case 2: //Humidity
                return [new DashboardRange({
                    name: 'Too Dry',
                    description: 'Value below threshold',
                    color: Utils.colors.red,
                    min: null,
                    max: 20,
                    icon: 'fa-circle-arrow-down'
                }), new DashboardRange({
                    name: 'Dry',
                    description: 'Value below threshold',
                    color: Utils.colors.yellow,
                    min: 20,
                    max: 30,
                    icon: 'fa-circle-arrow-down'
                }), new DashboardRange({
                    name: 'Comfortable',
                    description: 'Value within threshold',
                    color: Utils.colors.green,
                    is_default: true,
                    min: 30,
                    max: 70,
                }), new DashboardRange({
                    name: 'Humid',
                    description: 'Value above threshold',
                    color: Utils.colors.yellow,
                    min: 70,
                    max: 80,
                    icon: 'fa-circle-arrow-up'
                }), new DashboardRange({
                    name: 'Too Humid',
                    description: 'Value above threshold',
                    color: Utils.colors.red,
                    min: 80,
                    max: null,
                    icon: 'fa-circle-arrow-up'
                })]
            case 3: //C02
                return [new DashboardRange({
                    name: 'Good',
                    description: 'Value within threshold',
                    color: Utils.colors.green,
                    min: null,
                    max: 1001,
                    is_default: true,
                }), new DashboardRange({
                    name: 'Moderate',
                    description: 'Value above threshold',
                    color: Utils.colors.yellow,
                    min: 1001,
                    max: 2001,
                    icon: 'fa-circle-arrow-up'
                }), new DashboardRange({
                    name: 'Unhealthy',
                    description: 'Value above threshold',
                    color: Utils.colors.red,
                    min: 2001,
                    max: 5001,
                    icon: 'fa-circle-arrow-up'
                }), new DashboardRange({
                    name: 'Very unhealthy',
                    description: 'Value above threshold',
                    color: Utils.colors.purple,
                    min: 5001,
                    max: 40000,
                    icon: 'fa-circle-arrow-up'
                }), new DashboardRange({
                    name: 'Hazardous',
                    description: 'Value above threshold',
                    color: Utils.colors.maroon,
                    min: 40000,
                    max: null,
                    icon: 'fa-circle-arrow-up'
                })]
            case 4: // VOC
                return [new DashboardRange({
                    name: 'Excellent',
                    description: 'Value within threshold',
                    color: Utils.colors.green,
                    min: null,
                    max: 221,
                    is_default: true
                }), new DashboardRange({
                    name: 'Moderate',
                    description: 'Value above threshold',
                    color: Utils.colors.yellow,
                    min: 221,
                    max: 661,
                    icon: 'fa-circle-arrow-up'
                }), new DashboardRange({
                    name: 'Poor',
                    description: 'Value above threshold',
                    color: Utils.colors.orange,
                    min: 661,
                    max: 2201,
                    icon: 'fa-circle-arrow-up'
                }), new DashboardRange({
                    name: 'Unhealthy',
                    description: 'Value above threshold',
                    color: Utils.colors.red,
                    min: 2201,
                    max: null,
                    icon: 'fa-circle-arrow-up'
                })]
            case 7: //PM 2.5
                return [new DashboardRange({
                    name: 'Good',
                    description: 'Value within threshold',
                    color: Utils.colors.green,
                    min: null,
                    max: 12.1,
                    is_default: true
                }), new DashboardRange({
                    name: 'Moderate',
                    description: 'Value above threshold',
                    color: Utils.colors.yellow,
                    min: 12.1,
                    max: 35.5,
                    icon: 'fa-circle-arrow-up'
                }), new DashboardRange({
                    name: 'USG',
                    description: 'Value above threshold',
                    color: Utils.colors.orange,
                    min: 35.5,
                    max: 55.5,
                    icon: 'fa-circle-arrow-up'
                }), new DashboardRange({
                    name: 'Unhealthy',
                    description: 'Value above threshold',
                    color: Utils.colors.red,
                    min: 55.5,
                    max: 150.5,
                    icon: 'fa-circle-arrow-up'
                }), new DashboardRange({
                    name: 'Very Unhealthy',
                    description: 'Value above threshold',
                    color: Utils.colors.purple,
                    min: 150.5,
                    max: 250.5,
                    icon: 'fa-circle-arrow-up'
                }), new DashboardRange({
                    name: 'Hazardous',
                    description: 'Value above threshold',
                    color: Utils.colors.maroon,
                    min: 250.5,
                    max: null,
                    icon: 'fa-circle-arrow-up'
                })]
            case 8: // PM 10
                return [new DashboardRange({
                    name: 'Good',
                    description: 'Value within threshold',
                    color: Utils.colors.green,
                    min: null,
                    max: 54,
                    is_default: true
                }), new DashboardRange({
                    name: 'Moderate',
                    description: 'Value above threshold',
                    color: Utils.colors.yellow,
                    min: 54,
                    max: 155,
                    icon: 'fa-circle-arrow-up'
                }), new DashboardRange({
                    name: 'USG',
                    description: 'Value above threshold',
                    color: Utils.colors.orange,
                    min: 155,
                    max: 255,
                    icon: 'fa-circle-arrow-up'
                }), new DashboardRange({
                    name: 'Unhealthy',
                    description: 'Value above threshold',
                    color: Utils.colors.red,
                    min: 255,
                    max: 355,
                    icon: 'fa-circle-arrow-up'
                }), new DashboardRange({
                    name: 'Very Unhealthy',
                    description: 'Value above threshold',
                    color: Utils.colors.purple,
                    min: 355,
                    max: 425,
                    icon: 'fa-circle-arrow-up'
                }), new DashboardRange({
                    name: 'Hazardous',
                    description: 'Value above threshold',
                    color: Utils.colors.maroon,
                    min: 425,
                    max: null,
                    icon: 'fa-circle-arrow-up'
                })]
            default:
                return [new DashboardRange({
                    name: 'Good',
                    description: 'Value within threshold',
                    color: Utils.colors.green,
                    min: null,
                    max: null,
                    is_default: true
                })]
        }
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/dashboard/modify_widgets/iaq/IAQWidget.ts